import { render } from "./FotoResumo.vue?vue&type=template&id=4a07729c"
import script from "./FotoResumo.vue?vue&type=script&lang=js"
export * from "./FotoResumo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__